import type { ApprovalAttributes } from '@/types/approval';
import {
  SERP_NOT_LOADED_MESSAGE,
  type SerpDocumentRef,
} from '@/utils/approval/serpDocument';

/** SERP 여신유예신청 — 레거시 appr_edit_forms_serp_lending_delay */
export const SERP_LENDING_DELAY_TYPE = 163;

export const isSerpLendingDelayType = (apvType: number): boolean =>
  apvType === SERP_LENDING_DELAY_TYPE;

/** EAI 응답 원문 — 저장 attributes.data 에 손대지 않고 그대로 보관 */
export type SerpLendingDelaySource = {
  BRAND_NM?: unknown;
  SHOP_ABBR_NM?: unknown;
  STA_DE?: unknown;
  END_DE?: unknown;
  DEF_AMT?: unknown;
  APRV_TITLE?: string | null;
  [key: string]: unknown;
};

export type SerpLendingDelayDraftSource = {
  code: number;
  attributes: SerpDocumentRef;
  display: { source?: SerpLendingDelaySource | null };
};

export type SerpLendingDelayState = SerpDocumentRef & {
  source: SerpLendingDelaySource;
  /** SERP 응답으로 자동 입력한 제목 — 이탈 경고는 이 값과 비교. 편집은 미사용 */
  autoSubject: string;
};

/** 레거시 `$('#subject').val(APRV_TITLE)` — 키가 없으면(undefined) 제목을 건드리지 않고, null 이면 비움 */
export const buildSerpLendingDelaySubject = (
  source: SerpLendingDelaySource,
): string | undefined => {
  if (source.APRV_TITLE === undefined) return undefined;
  return source.APRV_TITLE ?? '';
};

export const checkSerpLendingDelayBeforeSave = (
  state: SerpLendingDelayState | null | undefined,
): string | null => (state?.source ? null : SERP_NOT_LOADED_MESSAGE);

export const buildSerpLendingDelayAttributes = (
  state: SerpLendingDelayState | null | undefined,
  content: string,
): ApprovalAttributes | null =>
  state?.source
    ? {
        typeCode: state.typeCode,
        sequence: state.sequence,
        content,
        data: state.source,
      }
    : null;
